/* eslint-disable no-undef */
// @flow
import React from 'react'

type Props = {
  handleCheckboxChange: (label: string) => void,
  label: string,
  isChecked?: boolean,
  text?: string
}

type State = {
  isChecked?: boolean
}

class Checkbox extends React.Component<Props, State> {
  state = {
    isChecked: 'isChecked' in this.props ? this.props.isChecked : false
  }

  toggleCheckboxChange = () => {
    const { handleCheckboxChange, label } = this.props

    this.setState(({ isChecked }) => ({isChecked: !isChecked}))
    handleCheckboxChange(label)
  }

  render () {
    const { label } = this.props
    const { isChecked } = this.state

    return (
      <div>
        <input
          id={label}
          type='checkbox'
          value={isChecked}
          checked={isChecked}
          onChange={this.toggleCheckboxChange}
          style={{textTransform: 'capitalize'}}
        />
        <label htmlFor={label}>
          {this.props.text || label}
        </label>
      </div>
    )
  }
}

export default Checkbox



// WEBPACK FOOTER //
// ./app/javascript/packs/containers/shared/Checkbox.js